const ACCESS_TOKEN_KEY = "barista_access_token";
const REFRESH_TOKEN_KEY = "barista_refresh_token";

const safeGetStorage = (key) => {
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
};

const safeSetStorage = (key, value) => {
    try {
        if (value === null || value === undefined) {
            localStorage.removeItem(key);
            return;
        }

        localStorage.setItem(key, String(value));
    } catch {
        // Ignore storage errors (private mode, disabled storage, etc.)
    }
};

export const getAccessToken = () => safeGetStorage(ACCESS_TOKEN_KEY);

export const getRefreshToken = () => safeGetStorage(REFRESH_TOKEN_KEY);

export const setAuthSession = ({ accessToken, refreshToken }) => {
    safeSetStorage(ACCESS_TOKEN_KEY, accessToken || null);
    safeSetStorage(REFRESH_TOKEN_KEY, refreshToken || null);
};

export const clearAuthSession = () => {
    safeSetStorage(ACCESS_TOKEN_KEY, null);
    safeSetStorage(REFRESH_TOKEN_KEY, null);
};